const content: { [key: string]: string } = {
  earned: "Earned",
  potential: "Potential",
  notEarned: "Not Earned",
  unavailable: "Unavailable",
};

export default content;
